<template>
  <div>
    <Panel module="Financeiro" title="Conta Bancária" :showFilter="false" :showSearch="false" :showButtons="false">
      <div slot="content-main">
        <div class="bank-account-list-toolbar">
          <Button _key="btnBankAccountCreate" title="Conta Bancária" classIcon="fas fa-plus-circle" type="primary"
            size="small" :clicked="create" />
        </div>

        <Loading v-if="loading" type="line" :center="false" class="bank-account-list-loading" />

        <div v-if="!loading && bankAccounts.length === 0" class="bank-account-list-empty">
          <i class="fa-solid fa-building-columns"></i>
          <span>Nenhuma conta bancária encontrada. Crie uma para começar!</span>
        </div>

        <div v-if="bankAccounts.length > 0" class="bank-account-list-grid">
          <BankAccountCard v-for="bankAccount in bankAccounts" :key="bankAccount.id" :bankAccount="bankAccount"
            @edit="edit" @delete="openDeleteModal" />
        </div>
      </div>
    </Panel>

    <Modal title="Excluir Conta Bancária" :width="450" v-if="showModal('bankAccountDelete')">
      <div class="text-center">
        <p class="bank-account-list-delete-text">Tem certeza que deseja excluir esta conta?</p>
        <div class="bank-account-list-delete-account">
          <span class="bank-account-list-delete-name">{{ deleteTitle }}</span>
          <span v-if="bankAccountToDelete.fullName" class="bank-account-list-delete-description">
            {{ bankAccountToDelete.fullName }}
          </span>
        </div>
        <Confirmation :isModal="false" title="Deseja excluir?" type="danger" :confirmed="confirmDelete" />
      </div>
    </Modal>
  </div>
</template>

<script>
import Panel from "@/ui/layout/Panel";

import Button from "@/ui/forms/Button";
import Modal from "@/ui/forms/Modal";

import Confirmation from "@/ui/shared/Confirmation.vue";
import Loading from "@/ui/shared/Loading.vue";

import BankAccountCard from "../components/bankAccount/BankAccountCard.vue";

import BankAccountService from "../services/bankAccount.service";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "BankAccountListView",
  components: { Panel, Button, Modal, Confirmation, Loading, BankAccountCard },
  data() {
    return {
      bankAccounts: [],
      bankAccountToDelete: {},
      loading: true,
    };
  },
  mounted() {
    this.removeLoading(["panel"]);
    this.loadBankAccounts();
  },
  computed: {
    ...mapGetters("generic", ["showModal"]),
    deleteTitle() {
      return this.bankAccountToDelete.name || this.bankAccountToDelete.bankName;
    },
  },
  methods: {
    ...mapMutations("generic", ["openModal", "hideModal", "removeLoading"]),
    async loadBankAccounts() {
      this.loading = true;
      try {
        const response = await BankAccountService.getAll();
        this.bankAccounts = response.content.items || [];
      } finally {
        this.loading = false;
      }
    },
    create() {
      this.$router.push({ name: "bankAccountCreateNew" });
      this.removeLoading(["btnBankAccountCreate"]);
    },
    edit(bankAccount) {
      this.$router.push({
        name: "bankAccountUpdateNew",
        params: { id: bankAccount.id },
      });
    },
    openDeleteModal(bankAccount) {
      this.bankAccountToDelete = bankAccount;
      this.openModal("bankAccountDelete");
    },
    async confirmDelete() {
      try {
        await BankAccountService.remove([this.bankAccountToDelete.id]);
        this.hideModal();
        await this.loadBankAccounts();
      } catch (error) {
        console.error(error);
      } finally {
        this.removeLoading(["confirm", "notConfirm"]);
      }
    },
  },
};
</script>

<style scoped>
.bank-account-list-loading {
  margin-bottom: 20px;
}

.bank-account-list-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  padding-top: 8px;
}

.bank-account-list-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 48px 0;
  color: var(--text-muted);
  font-size: 14px;
}

.bank-account-list-empty i {
  font-size: 40px;
  color: var(--color-brand-light);
}

.bank-account-list-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.bank-account-list-delete-text {
  font-size: 14px;
  color: var(--text-primary);
  margin-bottom: 14px;
}

.bank-account-list-delete-account {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 12px 16px;
  border: 1px solid var(--border-subtle);
  border-radius: 12px;
  background: var(--bg-elevated);
  margin-bottom: 20px;
}

.bank-account-list-delete-name {
  font-size: 15px;
  font-weight: 500;
  color: var(--text-primary);
}

.bank-account-list-delete-description {
  font-size: 12px;
  color: var(--text-muted);
  font-style: italic;
}
</style>
